import React from 'react';
import { JobPriority } from '../../types/job';
import { useTranslation } from 'react-i18next';

export const ListingOptions: React.FC<{ priorities: JobPriority[] }> = ({ priorities }) => {
  const { t } = useTranslation('jobs');

  return (
    <ul className="grid md:grid-cols-2 gap-4 mb-6">
      {priorities.map(option => (
        <li key={option.id} className="flex items-start">
          <div className="flex-1 flex-row items-start gap-2">
            <p className="text-secondary font-bold">
              <span className="text-xs font-bold">
                {t(`publish.priorities.${option.key}.label`)}
              </span>{' '}
              <span className="text-xs font-normal">
                — {option.cost} {option.cost > 1 ? 'credits' : 'credit'}
              </span>
            </p>
            <p className="text-secondary text-xs flex flex-col flex-wrap">
              {t(`publish.priorities.${option.key}.description`)}
            </p>
          </div>
        </li>
      ))}
    </ul>
  );
};
